import RfiReassignForm from './RfiReassignForm.component';

export default RfiReassignForm;
